module.exports = "/_next/static/images/footer-1-b1ea405bbd24bc7b0261621da7184acf.png";